import React from 'react';
import { Route, Switch, withRouter } from 'react-router';
import { CookiesProvider } from 'react-cookie';
import { QueryClient, QueryClientProvider } from 'react-query';
import store from './webStore';
import './WebModules';
import RailInfoSystemReducers from '../Mobile-mmt-react-native/apps/rails/src/pages/RIS/PnrStatus/RailInfoSystemReducers';
import railsLandingReducer from "../Mobile-mmt-react-native/apps/rails/src/pages/RailsLandingPage/Store/RailsLandingReducer";
import railsVernacularReducer from "../Mobile-mmt-react-native/apps/rails/src/vernacular/vernacularReducer";
//import railsAdtechReducer from "../Mobile-mmt-react-native/src/adsConfig/adTechReducer";
import { injectAsyncReducer } from "../Mobile-mmt-react-native/packages/legacy-commons/AppState/asyncStore";
import railsUserVerificationReducer from '../Mobile-mmt-react-native/apps/rails/src/pages/User/UserVerification/UserVerificationReducer';
import { defaultLanguage, setSelectedLanguageProvider } from '../Mobile-mmt-react-native/apps/rails/src/vernacular/VernacularConfig';
import { initialiseCommonHeaders } from "../Mobile-mmt-react-native/apps/rails/src/fetch2";
import TrainScheduleReducers
  from "../Mobile-mmt-react-native/apps/rails/src/pages/RIS/TrainSchedule/TrainScheduleUtils/TrainScheduleReducers";
import LiveStationReducer
  from "../Mobile-mmt-react-native/apps/rails/src/pages/RIS/LiveStation/Util/liveStationReducer.js";
import LiveTrainStatusReducer from "../Mobile-mmt-react-native/apps/rails/src/pages/RIS/LiveTrainStatus/Util/LiveTrainStatusReducer.js"
import {
    RailsLanding,
    RailsCalendar,
    RailsCityPicker,
    TrainsBookingPolicy,
    OtpVerification,
    CreateNewAccount,
    ForgotUsername,
    RailsCreateAccountSuccess,
    RailsPasswordReminder,
    RailsReviewContainer,
    IrctcWebPage,
    ForgotPassword,
    ForgotIrctcPassword,
    WebViewWrapper,
    BookBreakJourney,
    WebViewForError,
    RailsListingAsync,
    InfoServiceAsync,
    RailsTravelerAsync,
    RailsRetryAsync,
    RailsThankYouAsync,
    NeedHelp,
    RailsMealsThankYou
  } from "./WebRouterAsyncCompLoader";


export const withRouterState = (Component) => {
  return (props) => {
    return <Component {...props.location.state} {...props.match.params} {...props} />
  }
}

if (typeof window === "object") {
 // injectAsyncReducer('railsAdtechReducer', railsAdtechReducer);
  injectAsyncReducer('railsVernacular', railsVernacularReducer);
  injectAsyncReducer('railsLanding', railsLandingReducer);
  injectAsyncReducer('railsUserVerification', railsUserVerificationReducer);
  injectAsyncReducer('trainScheduleReducer', TrainScheduleReducers);
  injectAsyncReducer('railInfoReducer', RailInfoSystemReducers);
  injectAsyncReducer('liveStationReducer', LiveStationReducer);
  injectAsyncReducer('liveTrainStatusReducer',LiveTrainStatusReducer);
  (() => {
    const state = store.getState;
    setSelectedLanguageProvider(() => {
      try {
        return state().railsVernacular.selectedLanguage;
      } catch (e) {
        return defaultLanguage;
      }
    });
  })();
}
initialiseCommonHeaders();

const queryClient = new QueryClient();

const WebRouter = () => (
  <CookiesProvider>
     <QueryClientProvider client={queryClient}>
    <Switch>
      {/*<Route exact path="/" component={withRouterState(RailsLanding)}/>*/}
      <Route exact path="(/pwa/v2|/booking|/railways/search)" component={withRouterState(RailsLanding)} />
      <Route exact path="(/pwa/v2|/booking|/railways/search)/railsCreateAccountPage" component={withRouterState(CreateNewAccount)} />
      <Route exact path="(/pwa/v2|/booking|/railways/search)/railsOtpVerification" component={withRouterState(OtpVerification)} />
      <Route exact path="(/pwa/v2|/booking|/railways/search)/railsForgotUsername" component={withRouterState(ForgotUsername)} />
      <Route exact path="(/pwa/v2|/booking|/railways/search)/railsCreateAccountSuccessPage" component={withRouterState(RailsCreateAccountSuccess)} />
      <Route exact path="(/pwa/v2|/booking|/railways/search)/railsCalendar" component={withRouterState(RailsCalendar)} />
      <Route exact path="(/pwa/v2|/booking|/railways/search)/railsCityPicker" component={withRouterState(RailsCityPicker)} />
      <Route path="(/pwa/v2|/booking|/railways/search)/(railsListingPage|listing)" component={withRouterState(RailsListingAsync)} />
      <Route path="(/pwa/v2|/booking|/railways)/listing" component={withRouterState(RailsListingAsync)} />
      <Route path="(/pwa/v2|/booking|/railways/search)/railsTravelerPage" component={withRouterState(RailsTravelerAsync)} />
      <Route exact path={"(/pwa/v2|/booking|/railways/search)/bookBreakJourney"} component={withRouterState(BookBreakJourney)} />
      <Route exact path={"(/pwa/v2|/booking|/railways/search)/webViewForError"} component={withRouterState(WebViewForError)} />
      <Route path="(/pwa/v2|/booking|/railways/search)/trainsBookingPolicy" component={withRouterState(TrainsBookingPolicy)} />
      <Route path="(/pwa/v2|/booking|/railways/search)/railsPasswordReminder" component={withRouterState(RailsPasswordReminder)} />
      <Route path="(/pwa/v2|/booking|/railways/search)/railsReviewPage" component={withRouterState(RailsReviewContainer)} />
      <Route path="(/pwa/v2|/booking|/railways/search)/openIrctcPage" component={withRouterState(IrctcWebPage)} />
      <Route path="(/pwa/v2|/booking|/railways/search)/forgotPassword" component={withRouterState(ForgotPassword)} />
      <Route path="(/pwa/v2|/booking|/railways/search)/forgotIrctcPassword" component={withRouterState(ForgotIrctcPassword)} />
      <Route path="(/pwa/v2|/booking|/railways/search)/webView" component={withRouterState(WebViewWrapper)} />
      <Route path="(/pwa/v2|/booking|/railways/search)/railsRetryBooking" component={withRouterState(RailsRetryAsync)} />
      <Route path="(/pwa/v2|/booking|/railways/search)/needHelp" component={withRouterState(NeedHelp)} />
      <Route path="(/pwa/v2|/booking|/railways/search)/mobileThankyouPage" component={withRouterState(RailsThankYouAsync)} />
      <Route path="/railways/food/thankyou" component={withRouterState(RailsMealsThankYou)} /> {/* Planned for phase-out */}
      <Route path="/railways/rf-food/thankyou" component={withRouterState(RailsMealsThankYou)} />
      <Route path="/pwa" component={withRouterState(RailsThankYouAsync)} />
      <Route path="(/infoService|/railways|/)" component={InfoServiceAsync} />
    </Switch>
    </QueryClientProvider>
  </CookiesProvider>
);


export default WebRouter;

